import React from 'react';
import './RankMatchSearchNoticeModal.css';
import PageButton from '../../elements/PageButton/PageButton';

const PAGE_ID = 'RankMatchSearchNoticeModal';

// Почему игрок, нажавший «Рейтинговый матч», оказался не на экране поиска
export const RANK_MATCH_SEARCH_NOTICES = {
  // Запрос не дошел, не дождался ответа или сервер ответил неожиданно — раньше
  // такой отказ только писался в консоль, и кнопка для игрока «не работала»
  JOIN_FAILED: 'JOIN_FAILED',
  // Тот же игрок начал поиск в другой вкладке или на другом устройстве: сервер
  // перенес поиск туда (см. перехват в /api/rank-match/join)
  SEARCH_SUPERSEDED: 'SEARCH_SUPERSEDED',
};

const NOTICE_TEXTS = {
  [RANK_MATCH_SEARCH_NOTICES.JOIN_FAILED]: {
    title: 'Не удалось начать поиск',
    text: 'Сервер не ответил. Проверьте подключение к интернету и попробуйте еще раз.',
  },
  [RANK_MATCH_SEARCH_NOTICES.SEARCH_SUPERSEDED]: {
    title: 'Поиск продолжен в другом окне',
    text: 'Вы начали поиск рейтингового матча в другой вкладке или на другом устройстве — поиск идет там.',
  },
};

function RankMatchSearchNoticeModal({notice, onHide}) {
  const {title, text} = NOTICE_TEXTS[notice] || NOTICE_TEXTS[RANK_MATCH_SEARCH_NOTICES.JOIN_FAILED];

  return (
    <div className="rank-match-search-notice-overlay" onClick={onHide} role="dialog" aria-modal="true">
      <div className="rank-match-search-notice-modal" onClick={(e) => e.stopPropagation()}>
        <h2 className="rank-match-search-notice-title">{title}</h2>
        <p className="rank-match-search-notice-text">{text}</p>
        <div className="main-menu-buttons rank-match-search-notice-buttons">
          <PageButton onClick={onHide} pageId={PAGE_ID} buttonId="hide" buttonValue={notice}>
            Скрыть
          </PageButton>
        </div>
      </div>
    </div>
  );
}

export default RankMatchSearchNoticeModal;
